<template>
  <div>
<!--  <div class="container">-->
<!--    <LinkButton-->
<!--      v-bind="{routeName: 'Units'}">-->
<!--      Back to Rosters-->
<!--    </LinkButton>-->
<!--  </div>-->
  <div class="padding-9">
    <div class="typed-on-paper">
      <h1 style="font-size: larger" class="text-align-center">ROSTERS</h1>

<!--      <p class="text-align-left">-->
<!--        Here you can find information about the units that comprise the "Flying Tin Cans".-->
<!--      </p>-->
      <p class="text-align-left">
        Our group consists of {{ base_units.length - 4 }} operational squadrons, as well as 4 reserve squadrons. Depending on the campaign, operational squadrons may
        represent different historical units, in order to fit the actual unit deployment in the area of operations at the time
        the campaign is taking place. Holding Units (RSV) and HQ Units assist in the
        administrative process of dealing with members who go on leave or
        contribute in ways other than flying.
      </p>
      <DivLinkButton
        class=""
        v-for="unit in base_units"
        v-bind:key="unit.id"
        v-bind="{routeName: 'BaseUnitInfo', routeParams: {unit_id: unit.id}}"
      >
        <span class="heading">{{ unit.name }}</span>
      </DivLinkButton>
<!--      <table class="center">-->
<!--        <tr>-->
<!--          <th>ALLIES</th>-->
<!--          <th>AXIS</th>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td>-->
<!--              <DivLinkButton-->
<!--                class=""-->
<!--                v-for="unit in base_units"-->
<!--                v-bind:key="unit.id"-->
<!--                v-bind="{routeName: 'BaseUnitInfo', routeParams: {unit_id: unit.id}}"-->
<!--              >-->
<!--                <span class="heading">{{ unit.name }}</span>-->
<!--              </DivLinkButton>-->
<!--          </td>-->
<!--          <td>-->
<!--            <DivLinkButton-->
<!--              class=""-->
<!--              v-for="unit in base_units"-->
<!--              v-bind:key="unit.id"-->
<!--              v-bind="{routeName: 'BaseUnitInfo', routeParams: {unit_id: unit.id}}"-->
<!--            >-->
<!--              <span class="heading">{{ unit.name }}</span>-->
<!--            </DivLinkButton>-->
<!--          </td>-->
<!--        </tr>-->
<!--      </table>-->

      <!--      <h2>Units</h2>-->
<!--      <p class="text-align-left">-->
<!--        The group is subdivided into {{ base_units.length }} Units.-->
<!--&lt;!&ndash;        Not all base units are active at all time. Some units are set to inactive depending on the campaign requirements and membership&ndash;&gt;-->
<!--&lt;!&ndash;        numbers. &ndash;&gt;-->
<!--         These do not represent any specific unit or faction in particular, but rather serve to organize their members and their membership within the group.-->
<!--         Each Unit gets their historic context and faction through the historic units they represent in each campaign.-->
<!--      </p>-->
<!--      <p class="text-align-left">-->
<!--        "Flying Tin Cans" Units are listed on the left in the vertical menu, under Units. Click on the name of the Unit to see more information.-->
<!--      </p>-->
<!--      <h2>Historical Squadrons</h2>-->
<!--      <p class="text-align-left">-->
<!--        For each of our Campaigns, our Units represent selected Historical Squadrons from the era,-->
<!--        chosen by our Campaign Design team so as to provide the necessary historical backdrop to our Campaign.-->
<!--        The list not only includes units at the squadron level, but at the Wing, or Group levels.-->
<!--      </p>-->
<!--      <p class="text-align-left">-->
<!--        A specific structure consisting of various Historical Squadrons is put in place for each campaign,-->
<!--        in an effort to reflect the structure of the forces depicted in each unfolding Campaign being played out.-->
<!--        "Flying Tin Can" Units are then assigned to these Historical Squadrons.-->
<!--&lt;!&ndash;        The active base units are representing their assigned historic unit while that particular&ndash;&gt;-->
<!--&lt;!&ndash;        campaign is ongoing.&ndash;&gt;-->
<!--      </p>-->
<!--      <p class="text-align-left">-->
<!--        The historical units are listed on the left in the vertical menu. The pages to show more information about-->
<!--        the historical units are still under development. Click on the button labeled "Historical units" if you can't see the list. Additionally-->
<!--        you can filter the list to show only units from a particular faction by using the faction buttons, or search for a-->
<!--        unit with a specific name by using the search field.-->
<!--      </p>-->
<!--      <h2>Holding (RSV) & HQ Units</h2>-->
<!--      <p class="text-align-left">-->
<!--        Holding Units (RSV) and HQ Units assist in the-->
<!--        administrative process of dealing with members who go on leave or-->
<!--        contribute in ways other than flying.-->
<!--      </p>-->
<!--      <p class="text-align-left">-->
<!--        Holding Units (RSV) are designed to take on long-standing members who go-->
<!--        on leave for an extended period of time.-->
<!--      </p>-->
    </div>

  </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex"
import statusConv from "../../resource/statusConverter"
import DivLinkButton from "../basic_comp/DivLinkButton"
import HideableDiv from "../basic_comp/HideableDiv"
import LinkButton from "../basic_comp/LinkButton"

export default {
  name: "UnitGeneralComp",
  components: {
    DivLinkButton,
    HideableDiv,
    LinkButton
  },
  mixins: [
    statusConv
  ],
  props: {

    depl_unit_id: {
      type: Number,
      default: null
    },
    base_unit_id: {
      type: Number,
      default: null
    },
    base_unit_name: {
      type: [Number, String],
      default: null
    },
    hist_unit_name: String,
    children: {
      type: Array,
      default: function () {
        return [];
      }
    },
    hist_unit_code: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: null
    }
  },
  mounted () {

    this.$store.dispatch('unitInfo/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "campaign_info_unit",
          campaign_id: this.campaign_id
        },
        data_array_name: "campaign_units",
      }
    ).catch(error => {
      console.log(error.message);
    });

    this.$store.dispatch('missionStore/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "campaign_unit_plane_asset_status",
          campaign_id: this.campaign_id
        },
        data_array_name: "campaign_unit_plane_asset_status",
      }
    ).catch(error => {
      console.log(error.message);
    });

    this.$store.dispatch('unitInfo/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "campaign_unit_member_info",
          campaign_id: this.campaign_id
        },
        data_array_name: "member_info",
      }
    ).catch(error => {
      console.log(error.message);
    });

    this.$store.dispatch('unitInfo/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "rank_lookup",
        },
        data_array_name: "rank_lookup"
      }
    ).catch(error => {
      console.log(error.message);
    });

    this.$store.dispatch('unitInfo/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "base_unit",
        },
        data_array_name: "base_units"
      }
    ).catch(error => {
      console.log(error.message);
    });

    this.$store.dispatch('unitInfo/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "hist_unit_info",
        },
        data_array_name: "hist_units"
      }
    ).catch(error => {
      console.log(error.message);
    });

    this.$store.dispatch('unitInfo/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "rank_lookup",
        },
        data_array_name: "rank_lookup"
      }
    ).catch(error => {
      console.log(error.message);
    });
  },

  computed: {

    ...mapState('unitInfo', {
      base_units: state => state.base_units,
      hist_units: state => state.hist_units
    }),

    ...mapGetters("unitInfo", [
      "filterByKey",
      "filterByString"
    ]),

    ...mapState("missionStore", {

      campaign: state => state.campaign[0],
    }),

    ...mapGetters("unitInfo", [
      "nestedData",
    ]),

    campaign_unit_stats: function() {

      return this.filterByKey("campaign_unit_plane_asset_status", "depl_unit_id", this.depl_unit_id);
    }

  }
}
</script>

<style scoped>

table, th, td {
  border: 2px solid darkblue;
}
table.center {
  margin-left: auto;
  margin-right: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/unit/UnitGeneralComp.vue